import React from 'react';
import ArrFloatingPanel from '../../../components/common/arr-floating-panel/ArrFloatingPanel';
import {Box, Typography} from '@mui/material';

const FloatingPanelDemo: React.FC = () => {
  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        ArrFloatingPanel Demo
      </Typography>
      <ArrFloatingPanel buttonTitle="Open Floating Panel" panelTitle="Title">
        <Box>
          <Typography>
            This is some mock content inside the floating panel. This is some
            mock content inside the floating panel. This is some mock content
            inside the floating panel. This is some mock content inside the
            floating panel. This is some mock content inside the floating panel.
            This is some mock content inside the floating panel. This is some
            mock content inside the floating panel. This is some mock content
            inside the floating panel. This is some mock content inside the
            floating panel. This is some mock content inside the floating panel.
            This is some mock content inside the floating panel. This is some
            mock content inside the floating panel. This is some mock content
            inside the floating panel. This is some mock content inside the
            floating panel.
          </Typography>
        </Box>
      </ArrFloatingPanel>
    </Box>
  );
};

export default FloatingPanelDemo;
